__webpack_require__.p = "https://dttservicearea.nbtc.go.th/webapp/";